import React from 'react';
import '@/assets/styles/components/tooltip.styles.scss';

type TooltipProps = {
	text: string;
	position?: 'top' | 'bottom' | 'left' | 'right';
	isVisible: boolean;
	children: React.ReactNode;
};

const Tooltip: React.FC<TooltipProps> = ({ text, position = 'top', isVisible, children }) => {
	return (
		<div className="tooltip-container">
			<div className="tooltip-wrapper">
				{children}
				{isVisible && (
					<span className={`tooltip-text tooltip-${position}`}>
						{text}
						<span className={`tooltip-arrow tooltip-arrow-${position}`} />
					</span>
				)}
			</div>
		</div>
	);
};

export default Tooltip;
